import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {  
  Table,
  Header,
  Form,
  Icon,
  Loader,
  Button
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { userLockActions } from '../../actions/userlock.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { getBlockModeLabel } from '../../helpers/user';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class UserLockNotificationsScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        username: null,
        computerName: null,
        period: ''
    };
  }

  static get propTypes() { 
    return { 
       registers: PropTypes.any,
       loading: PropTypes.bool,       
    }; 
  }

  componentDidMount() {    
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}`}, () => this.fetchRegisters());        
  }

  handlePageChange(activePage) {      
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {  
    this.setState({ period }, () => this.fetchRegisters());
  }

  handleUsernameChange(username) {    
    this.setState({ username, page: 1 });
    this.handleSearchDebounced();
  }

  handleComputerNameChange(computerName) {    
    this.setState({ computerName, page: 1 });
    this.handleSearchDebounced();
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;    
    const { page, username, period, computerName } = this.state;     
    
    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(userLockActions.fetch({ page, username, computerName, startDate, endDate, orderBy: "EventTime", ascending: false, export: isExport === true, exportPdf: isExport === 'pdf' }));
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  exportPdf() {
    this.fetchRegisters('pdf');
  }

  render() {    
    const { registers, loading } = this.props;    
    const { period } = this.state;

    return (
      <Fragment>        
        <Header>
          <h1>Acessos de Usuários</h1>   
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Data Evento'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />                          
            <Form.Input icon='search' label='Username' onChange={(e, data) => this.handleUsernameChange(data.value)} loading={loading} />
            <Form.Input icon='search' label='Máquina' onChange={(e, data) => this.handleComputerNameChange(data.value)} loading={loading} />
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> XLSX
            </Form.Button>
            <Form.Button onClick={() => this.exportPdf()} label='&nbsp;'>
              <Icon name='file pdf' /> PDF
            </Form.Button>
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Data Evento</Table.HeaderCell>                    
                    <Table.HeaderCell>Username</Table.HeaderCell>                    
                    <Table.HeaderCell>Tipo</Table.HeaderCell>
                    <Table.HeaderCell>Máquina</Table.HeaderCell> 
                    <Table.HeaderCell>Modo Bloqueio</Table.HeaderCell>                                                                                                                   
                    <Table.HeaderCell>Horário Jornada</Table.HeaderCell>                                                          
                </Table.Row>
            </Table.Header>
            <Table.Body>                
                { registers && registers.Results && registers.Results.map((register) => {                    
                    return <Table.Row key={register.Id}>
                        <Table.Cell>{moment(register.EventTime).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>                        
                        <Table.Cell>{register.UserAccount}</Table.Cell>
                        <Table.Cell>{register.EventTypeLabel}</Table.Cell>
                        <Table.Cell>{register.ComputerName}</Table.Cell>                        
                        <Table.Cell>{getBlockModeLabel(register.BlockMode)}</Table.Cell>                        
                        <Table.Cell>{register.WorkHours}</Table.Cell>                        
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}        
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />        
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { userlock } = state;        
  return { 
    registers: userlock || null,
    loading: userlock.loading    
  };
}

const connectedUserLockNotificationsScreen = connect(mapStateToProps)(UserLockNotificationsScreen);
export { connectedUserLockNotificationsScreen as UserLockNotificationsScreen };
